document.addEventListener('DOMContentLoaded', function () {

  /* ---------------- Sticky / solid header on scroll ---------------- */
  var header = document.querySelector('[data-site-header]');
  function updateHeader(){
    if(!header) return;
    if(window.scrollY > 40){ header.classList.add('is-solid'); }
    else { header.classList.remove('is-solid'); }
  }
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive:true });

  /* ---------------- Mobile nav ---------------- */
  var mobileToggle = document.querySelector('[data-mobile-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  var mobileClose = document.querySelector('[data-mobile-close]');
  if (mobileToggle && mobileNav){
    mobileToggle.addEventListener('click', function(){
      mobileNav.classList.add('is-open');
      header && header.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }
  if (mobileClose && mobileNav){
    mobileClose.addEventListener('click', closeMobileNav);
  }
  function closeMobileNav(){
    mobileNav.classList.remove('is-open');
    header && header.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  /* ---------------- Reveal on scroll ---------------- */
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length){
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting){
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    revealEls.forEach(function(el){ io.observe(el); });
  } else {
    revealEls.forEach(function(el){ el.classList.add('is-visible'); });
  }

  /* ---------------- Accordions (product page) ---------------- */
  document.querySelectorAll('[data-accordion-trigger]').forEach(function(trigger){
    trigger.addEventListener('click', function(){
      var item = trigger.closest('.accordion-item');
      item.classList.toggle('is-open');
    });
  });

  /* ---------------- Size swatches ---------------- */
  document.querySelectorAll('[data-size-swatch]').forEach(function(btn){
    btn.addEventListener('click', function(){
      if (btn.disabled) return;
      var group = btn.closest('[data-swatch-list]');
      group.querySelectorAll('.size-swatch').forEach(function(b){ b.classList.remove('is-selected'); });
      btn.classList.add('is-selected');
      var input = document.querySelector('[data-selected-variant-input]');
      if (input) input.value = btn.getAttribute('data-variant-id') || '';
      var addBtn = document.querySelector('[data-add-to-cart]');
      if (addBtn) addBtn.disabled = false;
    });
  });

  /* ---------------- Quantity stepper ---------------- */
  document.querySelectorAll('[data-qty-row]').forEach(function(row){
    var input = row.querySelector('input');
    row.querySelectorAll('[data-qty-step]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var step = parseInt(btn.getAttribute('data-qty-step'), 10);
        var val = Math.max(1, (parseInt(input.value,10) || 1) + step);
        input.value = val;
        input.dispatchEvent(new Event('change'));
      });
    });
  });

  /* ---------------- Sticky add-to-cart reveal ---------------- */
  var stickyAtc = document.querySelector('[data-sticky-atc]');
  var mainAtc = document.querySelector('[data-main-atc]');
  if (stickyAtc && mainAtc && 'IntersectionObserver' in window){
    var atcObserver = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        stickyAtc.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    atcObserver.observe(mainAtc);
  }

  /* ---------------- Cart drawer open/close ---------------- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartOverlay = document.querySelector('[data-cart-overlay]');
  document.querySelectorAll('[data-cart-toggle]').forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.preventDefault();
      openCartDrawer();
    });
  });
  document.querySelectorAll('[data-cart-close]').forEach(function(btn){
    btn.addEventListener('click', closeCartDrawer);
  });
  if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);

  function openCartDrawer(){
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartOverlay && cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCartDrawer(){
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartOverlay && cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  window.MODOURA_openCart = openCartDrawer;

  /* ---------------- AJAX add to cart ---------------- */
  document.querySelectorAll('[data-add-to-cart-form]').forEach(function(form){
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var formData = new FormData(form);
      var submitBtn = form.querySelector('[data-add-to-cart]');
      if (submitBtn){ submitBtn.disabled = true; submitBtn.dataset.originalText = submitBtn.dataset.originalText || submitBtn.textContent; submitBtn.textContent = 'Adding…'; }

      fetch('/cart/add.js', { method:'POST', body: formData, headers:{ 'Accept':'application/json' } })
        .then(function(res){ return res.json(); })
        .then(function(){ return refreshCartDrawer(); })
        .then(function(){
          openCartDrawer();
        })
        .catch(function(err){ console.error('Add to cart failed', err); })
        .finally(function(){
          if (submitBtn){ submitBtn.disabled = false; submitBtn.textContent = submitBtn.dataset.originalText; }
        });
    });
  });

  function refreshCartDrawer(){
    return fetch('/?section_id=cart-drawer')
      .then(function(res){ return res.text(); })
      .then(function(html){
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newDrawer = doc.querySelector('[data-cart-drawer]');
        if (newDrawer && cartDrawer){
          cartDrawer.innerHTML = newDrawer.innerHTML;
          bindCartLineEvents();
        }
        var newCount = doc.querySelector('[data-cart-count]');
        document.querySelectorAll('[data-cart-count]').forEach(function(el){
          if (newCount) el.textContent = newCount.textContent;
        });
      });
  }

  function bindCartLineEvents(){
    document.querySelectorAll('[data-cart-line-remove]').forEach(function(btn){
      btn.addEventListener('click', function(){
        updateCartLine(btn.getAttribute('data-key'), 0);
      });
    });
    document.querySelectorAll('[data-cart-line-qty]').forEach(function(input){
      input.addEventListener('change', function(){
        updateCartLine(input.getAttribute('data-key'), parseInt(input.value,10) || 0);
      });
    });
  }
  bindCartLineEvents();

  function updateCartLine(key, quantity){
    fetch('/cart/change.js', {
      method:'POST',
      headers:{ 'Content-Type':'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(refreshCartDrawer);
  }

  /* ---------------- Product gallery — click to jump main image ---------------- */
  document.querySelectorAll('[data-gallery-thumb]').forEach(function(thumb){
    thumb.addEventListener('click', function(){
      var target = document.querySelector('[data-gallery-main]');
      if (target) target.src = thumb.dataset.fullSrc;
    });
  });

  /* ---------------- Newsletter form (theme editor preview safe) ---------------- */
  document.querySelectorAll('[data-newsletter-form]').forEach(function(form){
    form.addEventListener('submit', function(){
      var btn = form.querySelector('button');
      if (btn) btn.textContent = 'Subscribed';
    });
  });

});
